import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c0dc5de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "related-melatis"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ontdek meer", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Verbonden Melati's", -1))
const _hoisted_4 = { class: "melatis" }
const _hoisted_5 = {
  key: 1,
  class: "tags"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Meer over", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.related.melatis?.length || _ctx.related.tags?.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          (_ctx.related.melatis?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createElementVNode("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.related.melatis, (melati) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: melati.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: '/melati/' + melati.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(melati.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.related.tags?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.related.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tag.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: '/thema/' + tag.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}